import { useCallback, useRef, useState } from 'react';

import { useApiClient } from '../providers/auth-provider';

export interface SlashCommandItem {
  name: string;
  description: string;
}

export interface UseSlashCommandsReturn {
  commands: SlashCommandItem[];
  status: 'idle' | 'loading' | 'success' | 'error';
  fetch: () => void;
}

export function useSlashCommands(): UseSlashCommandsReturn {
  const apiClient = useApiClient();
  const [commands, setCommands] = useState<SlashCommandItem[]>([]);
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const requestIdRef = useRef(0);

  const fetchCommands = useCallback(() => {
    const thisRequest = ++requestIdRef.current;
    setStatus('loading');
    apiClient
      .listSlashCommands()
      .then((data) => {
        if (thisRequest !== requestIdRef.current) return;
        setCommands(data);
        setStatus('success');
      })
      .catch(() => {
        if (thisRequest !== requestIdRef.current) return;
        setCommands([]);
        setStatus('error');
      });
  }, [apiClient]);

  return { commands, status, fetch: fetchCommands };
}
